<ul class="tabs switches2 theme2" [class.ul-width]="panels?.length == 1" *ngIf="theme === 'theme2'">
    <li class="tab switch" *ngFor="let panel of panels; let i = index" [class.step]="panel.step"
        [class.disabled]="panel.disabled" (click)="activateTab(panel)" [class.active]="panel.active">
        <ng-container *ngIf="counterActive">
            {{i+1}}
        </ng-container>
        <i class="material-icons left" *ngIf="panel.icon">
            {{panel.icon}}
        </i>
        <span class="pointer cursor-pointer" [class.on]="theme === 'theme2' && activePanel>=i"></span>
        <span class="title cursor-pointer" [class.onTitle]="theme === 'theme2' && activePanel>=i">
            <ng-container *ngTemplateOutlet="panel.label2"></ng-container>
            <ng-container *ngIf="panel.label">{{panel.label}}</ng-container>
        </span>
        <span class="ln" [class.onLn]="theme === 'theme2' && activePanel>=(i+1)"></span>
        <!-- <span class="deco"></span> -->
    </li>
</ul>
<div class="panels-wrapper">
    <div class="panel-container">
        <div *ngFor="let panel of panels" [attr.id]="panel.id" class="panel" [class.autoheight]="autoHeight"
            [class.panel-active]="panel.active">
            <ng-container *ngIf="panel.active">
                <div class="template-container" *ngTemplateOutlet="panel.content"></div>
            </ng-container>
        </div>
    </div>
</div>
<!-- <div class="next" *ngIf="theme === 'theme2'">
    <button class="btn btn-lg" (click)="next()" *ngIf="this.activePanel<this.totalPanel-1">
        Suivant
    </button>
</div> -->